// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__eyf2V","wide":"styles_wide__ghs42"};